// Material-UI
import { Grid, Paper, Typography } from '@material-ui/core'

// Components
import MyAccordionCtrl from '../../../../control/accordion/accordion'

// Hooks
import useTranslate from '../../../../i18n/useTranslate'

// Types
import { DocumentAdditionalInfo } from '../../../../services/web/types/requestWebServiceTypes'
import { getFileIconPath } from '../../../../utilities/pathImg'
import { convertDateToFormatEN, convertDateToFormatTH } from '../../../../utilities/date'

export interface PreviewUploadAdditionalDocProps {
    documentAdditionalInfo: DocumentAdditionalInfo[]
}

const PreviewUploadAdditionalDoc = (props: PreviewUploadAdditionalDocProps) => {
    const { documentAdditionalInfo } = props
    const translate = useTranslate()

    const renderDisplayDate = (val: any) => {
        let display = ''
        if (val) {
            display =
                translate.languageStore.currentLanguage === translate.languageKey.th
                    ? 'ล่าสุดวันที่ ' + convertDateToFormatTH(val)
                    : 'Last updated ' + convertDateToFormatEN(val)
        }
        return display
    }

    return (
        <MyAccordionCtrl title={translate.get('LABEL.UPLOAD_ADDITIONAL_DOC')}>
            <Grid container spacing={2}>
                {documentAdditionalInfo.map((e, index) => (
                    <Grid container item xs={12} key={e.topicID}>
                        <Grid container>
                            <Grid container item md={10} sm={9} xs={12} justify={'flex-start'}>
                                <Typography variant={'body2'}>
                                    {index + 1}. {e.topicName}{' '}
                                </Typography>
                            </Grid>

                            <Grid container item xs={12}>
                                <Paper
                                    variant="outlined"
                                    style={{
                                        width: '100%',
                                        padding: '10px 15px 15px 15px',
                                        margin: '5px',
                                        marginRight: '0px',
                                    }}
                                >
                                    {e.fileInfo.map((fileInfo) => {
                                        return (
                                            <Grid key={fileInfo.fileToken} item xs={12}>
                                                <Grid
                                                    container
                                                    style={{
                                                        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                                                        padding: '5px 0',
                                                    }}
                                                >
                                                    <Grid container item xs={10} alignItems="center">
                                                        <img
                                                            src={
                                                                process.env.PUBLIC_URL +
                                                                getFileIconPath(fileInfo.filename)
                                                            }
                                                            alt="file icon"
                                                            style={{
                                                                width: 24,
                                                                height: 24,
                                                                margin: 4,
                                                                marginRight: 10,
                                                            }}
                                                        />

                                                        <Typography
                                                            variant={'body2'}
                                                            style={{ wordBreak: 'break-word' }}
                                                        >
                                                            <a href={fileInfo.path} target="_blank" rel="noreferrer">
                                                                {fileInfo.filename}
                                                            </a>
                                                        </Typography>
                                                        <Typography
                                                            variant={'body2'}
                                                            style={{ padding: '0 10px', wordBreak: 'break-word' }}
                                                        >
                                                            {renderDisplayDate(fileInfo.date)}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        )
                                    })}
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                ))}
            </Grid>
        </MyAccordionCtrl>
    )
}

export default PreviewUploadAdditionalDoc
